import React, { useState, useEffect } from "react";
import RequestHandler from "util/RequestHandler";
import { useMediaQuery } from "react-responsive";

import {
  Table,
  Empty,
  Col,
  Row,
  Button,
  notification,
  Select,
  Input,
  Form,
  Radio,
  Modal,
  message,
  Card,
} from "antd";
import {
  SaveOutlined,
  QuestionCircleOutlined,
  PlusOutlined,
  CheckOutlined,
  CopyOutlined,
  CloseOutlined,
} from "@ant-design/icons";
import { ColumnHelper } from "util/TableHelper";
import CurrencyFormat from "react-currency-format";
const { Option } = Select;

const layout = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 18,
  },
};

const InvoicePay = (props) => {
  const [form] = Form.useForm();

  const isDesktopOrLaptop = useMediaQuery({
    query: "(min-device-width: 1024px)",
  });

  const isBigScreen = useMediaQuery({ query: "(min-device-width: 1500px)" });

  const [options, setOptions] = useState({ pageTitle: "FATURA ÖDEME" });
  const [productTypes, setProductTypes] = useState({
    data: [],
    loading: true,
  });
  const [products, setProducts] = useState({
    data: [],
    loading: true,
  });

  const [invoices, setInvoices] = useState({
    data: [],
    loading: false,
  });

  const [selectedPayInvoice, setSelectedPayInvoice] = useState({
    data: [],
    loading: false,
  });

  const [invoiceSubscriptions, setInvoiceSubscriptions] = useState({
    data: [],
    total: 0,
    loading: true,
  });
  const [defaultProducts, setDefaultProducts] = useState({
    data: [],
    total: 0,
    loading: true,
  });

  const [paymentMethod, setPaymentMethod] = useState("0");
  const [modalVisible, SetModalVisible] = useState(false);
  const [tenantBalance, setTenantBalance] = useState(0);
  const [loading, setLoading] = useState(false);
  const [selectedProductTypeId, setSelectedProductTypeId] = useState("");
  const [hideProductDropDown, setHideProductDropDown] = useState(true);
  const [hideInputArea, setHideInputArea] = useState(true);
  const [hideInvoiceTable, setHideInvoiceTable] = useState(true);
  const [hideAddButton, setHideAddButton] = useState(true);
  const [hidePayInvoiceTable, setHidePayInvoiceTable] = useState(true);
  const [product, setProduct] = useState("");
  const [subscriberNo, setSubscriberNo] = useState("");
  const [productType, setProductType] = useState("");
  const [selectedRowInvoice, setSelectedRowInvoice] = useState([]);
  const [modalText, setModalText] = useState("");
  const [copyIban, setCopyIban] = useState("TR123150075223123");
  const [copyAlici, setCopyAlici] = useState(
    "POLYNOM TEKNOLOJİ BİLGİSAYAR YAZILIMLARI BİLİŞİM DANIŞMANLIK VE SANAYİ ANONİM ŞİRKETİ"
  );
  const [copyPaymentCode, setCopyPaymentCode] = useState("");
  const notSelectedInvoice = () => {
    notification["warning"]({
      message: "Uyarı",
      description: "Lütfen ödenecek fatura seçin.",
      duration: 2,
    });
  };
  const [hideClearButton, setHideClearButton] = useState(true);

  useEffect(() => {
    setProductTypes({
      ...productTypes,
      loading: true,
    });
    RequestHandler.get(`/Invoice/GetProductTypes`, false, {
      rawResponse: true,
    }).then((response) => {
      if (response.status === 200) {
        setProductTypes({
          data: response.data,
          loading: false,
        });
      }
    });
  }, []);

  useEffect(() => {
    RequestHandler.get(`/InvoiceSubscription`, false, {
      rawResponse: true,
    }).then((response) => {
      if (response.status === 200) {
        setInvoiceSubscriptions({
          data: response.data.value,
          loading: false,
          total: response.data["@odata.count"],
        });
      } else {
        setInvoiceSubscriptions({
          data: [],
          loading: false,
          total: 0,
        });
      }
    });
  }, []);

  useEffect(() => {
    RequestHandler.post(`/BalanceHistory/CheckBalance`, {}, false).then(
      (response) => {
        setTenantBalance(response.balance);
      }
    );

    RequestHandler.get(`/BalanceHistory/GetInvoicePaymentCode`).then(
      (response) => {
        setCopyPaymentCode(response);
      }
    );
  }, []);

  const reListSubscriptions = () => {
    RequestHandler.get(`/InvoiceSubscription`).then((response) => {
      setInvoiceSubscriptions({
        data: response.value,
        loading: false,
        total: response["@odata.count"],
      });
    });
  };

  useEffect(() => {
    RequestHandler.post(`/Invoice/GetProducts`, {}, false, {
      rawResponse: true,
    }).then((response) => {
      if (response.status === 200) {
        setDefaultProducts({
          data: response.data,
          loading: false,
        });
      } else {
        setDefaultProducts({
          data: [],
          loading: false,
        });
      }
    });
  }, []);

  const getProducts = (value) => {
    setProducts({
      ...products,
      loading: true,
    });
    const filtervalue = "'" + value + "'";
    RequestHandler.post(
      `/Invoice/GetProducts?$filter=productTypeId eq  ${filtervalue}&$orderby=name`,
      {},
      false,
      { rawResponse: true }
    ).then((response) => {
      if (response.status === 200) {
        setProducts({
          data: response.data,
          loading: false,
        });
      } else {
        setProducts({
          data: [],
          loading: false,
        });
      }
    });
  };

  const handleSelectedProductTypes = (value) => {
    form.resetFields(["products", "subscriberNo", "invoiceSubscription"]);
    const productTypeName = productTypes.data.find(
      (item) => item.id == value
    )?.name;
    setProductType(productTypeName);
    setProduct("");
    setSubscriberNo("");
    setSelectedProductTypeId(value);
    setHideProductDropDown(false);
    setHideInvoiceTable(true);
    setHidePayInvoiceTable(true);
    setSelectedRowInvoice([]);
    getProducts(value);
  };

  const handleInputArea = (value) => {
    setHideInputArea(false);
    setProduct(value);
    setHideAddButton(false);
    setHideInvoiceTable(true);
    setHidePayInvoiceTable(true);
    setSelectedRowInvoice([]);
    setHideClearButton(false);
  };

  const onChangeSubscriberNo = (e) => {
    setSubscriberNo(e.target.value);
  };

  const checkInvoice = () => {
    setInvoices({
      loading: true,
    });


    RequestHandler.post(
      `/Invoice/CheckInvoice`,
      {
        productId: product,
        subscriberNo: subscriberNo,
        productType: productType,
      },
      false,
      { rawResponse: true }
    ).then((response) => {
      if (response.status === 200) {
        setInvoices({
          data: response.data,
          loading: false,
        });
        setHideInvoiceTable(false);
      } else {
        setInvoices({
          data: [],
          loading: false,
        });
        setHideInvoiceTable(true);
      }
    });
  };

  const payInvoice = () => {
    if (tenantBalance < parseFloat(selectedPayInvoice.data[0]?.totalAmount)) {
      setModalText(
        "Hesap bakiyesi yetersiz.Lütfen bakiye yükleyip tekrar deneyiniz."
      );
      SetModalVisible(true);
      return;
    }
    const productName =
      defaultProducts.data.find((x) => x.name == product)?.name ??
      defaultProducts.data.find((x) => x.id == product)?.name;

    RequestHandler.post(
      `/Invoice/PayInvoice`,
      {
        invoiceId: selectedPayInvoice.data[0].paymentTransactionQueryOId,
        invoiceAmount: selectedPayInvoice.data[0].invoiceAmount,
        invoiceNo: selectedPayInvoice.data[0].billNo,
        product: productName,
        productType: productType,
        expense: selectedPayInvoice.data[0].totalExpense,
        total: selectedPayInvoice.data[0].totalAmount,
        commission: selectedPayInvoice.data[0].commission,
        subscriberNo: selectedPayInvoice.data[0].subscriberNo1,
        invoiceDueDate: selectedPayInvoice.data[0].billDueDate,
        invoiceTerm: selectedPayInvoice.data[0].billTerm,
        productId: product,
      },
      false,
      { rawResponse: true }
    ).then((response) => {
      SetModalVisible(true);
      if (response.status === 200) {
        setModalText(response.data);
      } else {
        setModalText(
          "Fatura ödeme işleminizde bir hata oluştu. Daha sonra tekrar deneyiniz."
        );
      }
    });
  };

  const renderDecimal = (value) =>
    value !== null ? ColumnHelper.renderDecimal(value) : null;

  const columns = [
    {
      title: "Fatura No",
      dataIndex: "billNo",
      key: "billNo",
      align: "left",
    },
    {
      title: "Tutar",
      dataIndex: "invoiceAmount",
      key: "invoiceAmount",
      align: "left",
      render: (text, record) => {
        if (text === null) {
          return <div>{null}</div>;
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {",00"}
              </div>
            );
          }
        }
      },
    },
    {
      title: "Fatura Dönemi",
      dataIndex: "billTerm",
      key: "billTerm",
      align: "left",
    },
    {
      title: "Son Ödeme Tarihi",
      dataIndex: "billDueDate",
      key: "billDueDate",
      align: "left",
    },
  ];

  const selectedInvoiceTableColumns = [
    {
      title: "Fatura No",
      dataIndex: "billNo",
      key: "billNo",
      align: "left",
    },
    {
      title: "Fatura Dönemi",
      dataIndex: "billTerm",
      key: "billTerm",
      align: "left",
    },
    {
      title: "Son Ödeme Tarihi",
      dataIndex: "billDueDate",
      key: "billDueDate",
      align: "left",
    },
    {
      title: "Fatura Tutarı",
      dataIndex: "invoiceAmount",
      key: "invoiceAmount",
      align: "left",
      render: (text, record) => {
        if (text === null) {
          return <div>{null}</div>;
        } else {
          if (text.toString().includes(".") === true) {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
              </div>
            );
          } else {
            return (
              <div>
                <CurrencyFormat
                  value={parseFloat(text)}
                  displayType={"text"}
                  decimalSeparator={","}
                  thousandSeparator={"."}
                />
                {",00"}
              </div>
            );
          }
        }
      },
    },

    {
      title: "Komisyon",
      dataIndex: "commission",
      key: "commission",
      align: "left",
    },
    {
      title: "Masraf",
      dataIndex: "totalExpense",
      key: "totalExpense",
      align: "left",
      render: renderDecimal,
    },
    {
      title: "Toplam",
      dataIndex: "totalAmount",
      key: "totalAmount",
      align: "left",
      render: renderDecimal,
    },
  ];

  const onTableSelectChange = (selectedKeys) => {
    SetPayInvoiceTable(selectedKeys);
    setSelectedRowInvoice(selectedKeys);
  };

  const SetPayInvoiceTable = (value) => {
    const invoiceList = [];
    const payInvoice = invoices.data.find((item) => item.billNo == value);
    invoiceList.push(payInvoice);
    setSelectedPayInvoice({
      data: invoiceList,
      loading: false,
    });
    setHidePayInvoiceTable(false);
  };

  const openNotificationWithIcon = (type) => {
    notification[type]({
      message: "BAŞARILI",
      description: "Ekleme işlemi başarı ile gerçekleşti.",
      duration: 2,
    });
  };

  const handleSelectInvoiceSubscription = (value) => {
    const invoiceSubscription = invoiceSubscriptions.data.find(
      (item) => item.id == value
    );
    const productTypeId = productTypes.data.find(
      (item) => item.name == invoiceSubscription.productType
    )?.id;
    setSelectedProductTypeId(productTypeId);
    setHideProductDropDown(false);
    getProducts(productTypeId);
    setHideInputArea(false);
    setProductType(invoiceSubscription.productType);
    setProduct(invoiceSubscription.product);
    setSubscriberNo(invoiceSubscription.subscriberNo);
    setHideAddButton(true);
    setHideInvoiceTable(true);
    setHidePayInvoiceTable(true);
    setSelectedRowInvoice([]);
    setHideClearButton(false);
  };

  const onFinish = (values) => {
    const productName = products.data.find(
      (x) => x.id == values.products
    )?.name;
    RequestHandler.post(
      "/InvoiceSubscription",
      {
        name: values.name,
        product: productName,
        productType: values.productType,
        subscriberNo: values.subscriberNo,
      },
      false,
      { rawResponse: true }
    ).then((response) => {
      if (response.status === 200) {
        openNotificationWithIcon("success");
        reListSubscriptions();
        setLoading(false);
      } else {
        setLoading(false);
      }
    });
  };

  const handlePaymentMethodChange = (e) => {
    if (selectedRowInvoice.length == 0) {
      notSelectedInvoice();
    } else {
      setPaymentMethod(e.target.value);
    }
  };

  const clearFields = () => {
    setProductType("");
    setProduct("");
    setSubscriberNo("");
    setProducts({
      data: [],
      loading: false,
    });
    setHideAddButton(true);
    form.resetFields([
      "productType",
      "products",
      "subscriberNo",
      "invoiceSubscription",
    ]);
  };

  return (
    <>
      <Row>
        <Col xs={24} md={12} lg={16}>
          <p style={{ fontSize: "120%", marginTop: -5 }}>
            <SaveOutlined /> {options.pageTitle}
          </p>
        </Col>
      </Row>

      <div>
        <>
          <Form
            {...layout}
            form={form}
            fields={[
              { name: "productType", value: productType },
              { name: "products", value: product },
              { name: "subscriberNo", value: subscriberNo },
            ]}
            onFinish={onFinish}
          >
            <Row style={{ marginTop: "20px" }}>
              <Col xs={24} md={24} lg={12} xl={8}>
                <Card type="inner" title="Fatura Bilgileri" size="default">
                  <Form.Item name="invoiceSubscription" label="Abonelik">
                    <Select
                      name="invoiceSubscription"
                      loading={false}
                      onChange={handleSelectInvoiceSubscription}
                    >
                      {invoiceSubscriptions.data.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item name="productType" label="Kurum Tipi">
                    <Select
                      name="productTypes"
                      loading={productTypes.loading}
                      onChange={handleSelectedProductTypes}
                    >
                      {productTypes.data.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="products"
                    label="Kurum Adı"
                    hidden={hideProductDropDown}
                  >
                    <Select
                      autoClearSearchValue
                      showSearch
                      optionFilterProp="children"
                      name="products"
                      loading={products.loading}
                      value={product}
                      onChange={handleInputArea}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                    >
                      {products.data.map((item) => (
                        <Option key={item.id} value={item.id}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                  <Form.Item
                    name="subscriberNo"
                    label="Abone No"
                    hidden={hideInputArea}
                  >
                    <Input
                      type="text"
                      autoComplete="off"
                      name=""
                      onKeyDown={(evt) =>
                        evt.key === "e" && evt.preventDefault()
                      }
                      onKeyPress={(event) => {
                        if (!/[0-9]/.test(event.key)) {
                          event.preventDefault();
                        }
                      }}
                      onChange={onChangeSubscriberNo}
                    />
                  </Form.Item>
                  <Row
                    style={
                      isDesktopOrLaptop && !isBigScreen
                        ? { textAlign: "end", marginRight: "60px" }
                        : { textAlign: "end" }
                    }
                  >
                    <Col xs={24} md={8} lg={8} xl={8}>
                      <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        size="middle"
                        htmlType="submit"
                        onClick={() => setLoading(true)}
                        loading={loading}
                        hidden={hideAddButton}
                      >
                        Abonelik Ekle
                      </Button>
                    </Col>

                    <Col xs={24} md={8} lg={8} xl={8}>
                      <Button
                        type="primary"
                        icon={<CloseOutlined />}
                        htmlType="button"
                        onClick={clearFields}
                        hidden={hideClearButton}
                      >
                        Temizle
                      </Button>
                    </Col>
                    <Col xs={24} md={8} lg={8} xl={8}>
                      <Button
                        type="primary"
                        icon={<QuestionCircleOutlined />}
                        onClick={checkInvoice}
                        loading={invoices.loading}
                        hidden={hideInputArea}
                        style={{ width: "138px" }}
                      >
                        Fatura Sorgula
                      </Button>
                    </Col>
                  </Row>
                </Card>
              </Col>
              <Col xs={24} md={24} lg={12} xl={16}>
                {!hideInvoiceTable && (
                  <Card type="inner" title="Faturalar" size="default">
                    <>
                      <Table
                        rowSelection={
                          invoices.data != []
                            ? {
                                selectedRowKeys: selectedRowInvoice,
                                onChange: onTableSelectChange,
                                type: "radio",
                              }
                            : undefined
                        }
                        locale={{
                          emptyText: (
                            <Empty
                              image={Empty.PRESENTED_IMAGE_SIMPLE}
                              description="Veri Yok"
                            />
                          ),
                        }}
                        style={{
                          overflowX: "auto",
                          maxHeight: "100%",
                          width: "100%",
                        }}
                        columns={columns}
                        dataSource={invoices.data}
                        loading={invoices.loading}
                        pagination={false}
                        sortable={true}
                        rowKey="billNo"
                      ></Table>
                      <Row
                        hidden={hideInvoiceTable}
                        style={
                          isDesktopOrLaptop
                            ? { marginTop: "20px", textAlign: "end" }
                            : { marginTop: "20px" }
                        }
                      >
                        <Col xs={24} md={12} lg={12} xl={14}>
                          <p style={{ fontWeight: "bold" }}>
                            Hesap Bakiyesi : {renderDecimal(tenantBalance)}
                          </p>
                        </Col>
                        <Col xs={24} md={12} lg={12} xl={10}>
                          <Radio.Group
                            value={paymentMethod}
                            onChange={handlePaymentMethodChange}
                          >
                            <Radio.Button value="1">Hesaptan Öde</Radio.Button>
                            <Radio.Button value="2">
                              Sanal Pos ile Öde
                            </Radio.Button>
                          </Radio.Group>
                        </Col>
                      </Row>
                    </>
                  </Card>
                )}
              </Col>
            </Row>
          </Form>

          <Row
            id="table"
            style={{ marginTop: "20px" }}
            hidden={hidePayInvoiceTable}
          >
            <>
              <Col xs={24} md={24} lg={24}>
                <Table
                  locale={{
                    emptyText: (
                      <Empty
                        image={Empty.PRESENTED_IMAGE_SIMPLE}
                        description="Veri Yok"
                      />
                    ),
                  }}
                  style={{
                    overflowX: "auto",
                    maxHeight: "100%",
                    width: "100%",
                  }}
                  columns={selectedInvoiceTableColumns}
                  dataSource={selectedPayInvoice.data}
                  loading={selectedPayInvoice.loading}
                  pagination={false}
                  sortable={true}
                  rowKey="billNo"
                ></Table>
                <Row
                  hidden={hidePayInvoiceTable}
                  style={
                    isDesktopOrLaptop
                      ? {
                          marginTop: "20px",
                          textAlign: "end",
                          marginRight: "20px",
                        }
                      : { marginTop: "20px" }
                  }
                >
                  <Col xs={24} md={12} lg={24}>
                    <p style={{ fontWeight: 700 }}>
                      Mevcut Bakiye : {renderDecimal(tenantBalance)}
                    </p>
                    <p style={{ fontWeight: 700 }}>
                      Kalan Bakiye :
                      {" " +
                        renderDecimal(
                          tenantBalance -
                            selectedPayInvoice.data[0]?.totalAmount ?? 0
                        )}
                    </p>
                    <Button
                      type="primary"
                      icon={<CheckOutlined />}
                      onClick={payInvoice}
                      loading={loading}
                      hidden={paymentMethod == "0" ? true : false}
                    >
                      Tamamla
                    </Button>
                  </Col>
                </Row>
              </Col>
            </>
          </Row>
        </>
      </div>

      <Modal
        visible={modalVisible}
        centered={true}
        keyboard={true}
        onOk={() => {
          SetModalVisible(false);
          setTimeout(
            function () {
              window.location.reload();
            }.bind(this),
            300
          );
        }}
        onCancel={() => {
          SetModalVisible(false);
          setTimeout(
            function () {
              window.location.reload();
            }.bind(this),
            1000
          );
        }}
        destroyOnClose={true}
        width={
          tenantBalance < selectedPayInvoice.data[0]?.totalAmount ? 767 : 520
        }
        title={
          tenantBalance <
          parseFloat(selectedPayInvoice.data[0]?.totalAmount) ? (
            <p style={{ fontWeight: "400" }}>Bakiye Yükleme Yönlendirme</p>
          ) : (
            <p style={{ fontWeight: "400" }}>Fatura Ödeme İşlem Sonucu</p>
          )
        }
        footer={[
          <Button
            type="primary"
            icon={<PlusOutlined />}
            htmlType="submit"
            onClick={() => onFinish(form.getFieldValue())}
            loading={loading}
            hidden={hideAddButton}
            style={{ marginLeft: "20px" }}
          >
            Abonelik Ekle
          </Button>,
          <Button
            type="primary"
            onClick={() => {
              SetModalVisible(false);
              setTimeout(
                function () {
                  window.location.reload();
                }.bind(this),
                100
              );
            }}
          >
            Tamam
          </Button>,
        ]}
      >
        <>
          <Col xs={24} md={24} lg={24}>
            <p style={{ fontWeight: 500 }}>{modalText}</p>
          </Col>
          <>
            <Col
              xs={24}
              md={12}
              lg={24}
              hidden={
                !(
                  tenantBalance <
                  parseFloat(selectedPayInvoice.data[0]?.totalAmount)
                )
              }
            >
              <p>
                Havale/EFT işlemi sonrası yatırdığınız tutar otamatik olarak
                bakiyenize aktarılacaktır.
              </p>
              <p style={{ fontWeight: 650 }}>ALICI</p>
              <p>
                POLYNOM TEKNOLOJİ BİLGİSAYAR YAZILIMLARI BİLİŞİM DANIŞMANLIK VE
                SANAYİ ANONİM ŞİRKETİ{" "}
                <Button
                  icon={<CopyOutlined />}
                  style={{ fontSize: "130%", marginLeft: "20px" }}
                  onClick={() =>
                    navigator.clipboard
                      .writeText(copyAlici)
                      .then(() => message.success("Alıcı ismi Kopyalandı."))
                  }
                ></Button>
              </p>
              <p style={{ fontWeight: 650 }}>IBAN</p>
              <p>
                {copyIban}{" "}
                <Button
                  icon={<CopyOutlined />}
                  style={{ fontSize: "130%", marginLeft: "20px" }}
                  onClick={() =>
                    navigator.clipboard
                      .writeText(copyIban)
                      .then(() => message.success("Iban Kopyalandı."))
                  }
                ></Button>
              </p>
              <p style={{ fontWeight: 650 }}>AÇIKLAMA</p>
              <p>
                *Açıklama alanına ödeme kodunun eklenmemesi halinde bakiye
                yüklenemez.
              </p>
              <p>
                #1234{" "}
                <Button
                  icon={<CopyOutlined />}
                  style={{ fontSize: "130%", marginLeft: "20px" }}
                  onClick={() =>
                    navigator.clipboard
                      .writeText(copyPaymentCode)
                      .then(() => message.success("Ödeme Kodu Kopyalandı."))
                  }
                ></Button>
              </p>
            </Col>
          </>
        </>
      </Modal>
    </>
  );
};

export default InvoicePay;
